import {
  SCHEMES_ANALYTES,
  SCHEMES_ANALYTES_SUCCESS,
  SCHEMES_ANALYTES_FAIL,
  POST_RESULT,
  POST_RESULT_SUCCESS,
  POST_RESULT_FAIL,
  UPDATE_RESULT,
  UPDATE_RESULT_SUCCESS,
  UPDATE_RESULT_FAIL,
  GET_RESULT,
  GET_RESULT_SUCCESS,
  GET_RESULT_FAIL,
  GET_STATISTICS,
  GET_STATISTICS_SUCCESS,
  GET_STATISTICS_FAIL,
  POST_SERELOGY_VALUES,
  POST_SERELOGY_VALUES_SUCCESS,
  POST_SERELOGY_VALUES_FAIL,
  GET_SERELOGY_VALUES,
  GET_SERELOGY_VALUES_SUCCESS,
  GET_SERELOGY_VALUES_FAIL,
  GET_ANALYTE_RESULT_PARTICIPANT,
  GET_ANALYTE_RESULT_PARTICIPANT_SUCCESS,
  GET_ANALYTE_RESULT_PARTICIPANT_FAIL,
  GET_MICRO_RESULT_DATA,
  GET_MICRO_RESULT_DATA_SUCCESS,
  GET_MICRO_RESULT_DATA_FAIL,
  POST_MICRO_RESULT,
  POST_MICRO_RESULT_SUCCESS,
  POST_MICRO_RESULT_FAIL,
  POST_MICRO_VALUE,
  POST_MICRO_VALUE_SUCCESS,
  POST_MICRO_VALUE_FAIL,
  GET_MICRO_STATISTICS,
  GET_MICRO_STATISTICS_SUCCESS,
  GET_MICRO_STATISTICS_FAIL,
  GET_MICRO_VALUE_LIST,
  GET_MICRO_VALUE_LIST_SUCCESS,
  GET_MICRO_VALUE_LIST_FAIL,
  GET_ANALYTE_DATA,
  GET_ANALYTE_DATA_SUCCESS,
  GET_ANALYTE_DATA_FAIL,
  GET_RESULT_ANALYTE_DATA,
  GET_RESULT_ANALYTE_DATA_SUCCESS,
  GET_RESULT_ANALYTE_DATA_FAIL,
  UPDATE_MICRO_RESULT,
  UPDATE_MICRO_RESULT_SUCCESS,
  UPDATE_MICRO_RESULT_FAIL,
  GET_QUALITATIVE_ASSIGN,
  GET_QUALITATIVE_ASSIGN_FAIL,
  GET_QUALITATIVE_ASSIGN_SUCCESS,
  SAVE_STATISTICS_STATUS_REQUEST,
  SAVE_STATISTICS_STATUS_SUCCESS,
  SAVE_STATISTICS_STATUS_FAILURE,
} from "./actionTypes";

export const getSchemeAnalytesList = (
  id,
  page = 1,
  limit = 50,
  filters = {},
) => ({
  type: SCHEMES_ANALYTES,
  payload: { id, page, limit, filters },
});

export const getSchemeAnalytesListSuccess = (SchemeAnalytesList) => {
  // console.log(" response in success action:", SchemeAnalytesList);
  return {
    type: SCHEMES_ANALYTES_SUCCESS,
    payload: SchemeAnalytesList,
  };
};
export const getSchemeAnalytesListFail = (error) => {
  // console.log("Error response in fail action:", error);
  return {
    type: SCHEMES_ANALYTES_FAIL,
    payload: error,
  };
};

export const postResult = (result, id) => {
  console.log("🚀 Dispatching POST_RESULT Action:");
  console.log("📌 Result Data:", result);
  console.log("📌 User ID:", id);

  return {
    type: POST_RESULT,
    payload: { result, id },
  };
};

export const postResultSuccess = (result) => {
  console.log("✅ POST_RESULT_SUCCESS Action Dispatched:");
  console.log("📌 Response Data:", result);

  return {
    type: POST_RESULT_SUCCESS,
    payload: result,
  };
};

export const postResultFail = (error) => {
  console.error("❌ POST_RESULT_FAIL Action Dispatched:");
  console.error("📌 Error:", error);

  return {
    type: POST_RESULT_FAIL,
    payload: error,
  };
};

////////////////////////
export const updateResult = (result, id, callback) => {
  console.log("🚀 Dispatching POST_RESULT Action:");
  console.log("📌 Result Data:", result);
  console.log("📌 User ID:", id);

  return {
    type: UPDATE_RESULT,
    payload: { result, id, callback }, // ✅ include callback here
  };
};

export const updateResultSuccess = (result) => {
  console.log("✅ UPDATE_RESULT_SUCCESS Action Dispatched:");
  console.log("📌 Response Data:", result);

  return {
    type: UPDATE_RESULT_SUCCESS,
    payload: result,
  };
};

export const updateResultFail = (error) => {
  console.error("❌ UPDATE_RESULT_FAIL Action Dispatched:");
  console.error("📌 Error:", error);

  return {
    type: UPDATE_RESULT_FAIL,
    payload: error,
  };
};
////////////////////////////////
export const getResultsList = (id, page, limit, filters = {}) => ({
  type: GET_RESULT,
  payload: { id, page, limit, filters },
});

export const getResultsListSuccess = (ResultList) => {
  return {
    type: GET_RESULT_SUCCESS,
    payload: ResultList,
  };
};

export const getResultsListFail = (error) => {
  return {
    type: GET_RESULT_FAIL,
    payload: error,
  };
};
////////////////////////////////
export const getStatisticsList = (id) => ({
  type: GET_STATISTICS,
  payload: id,
});

export const getStatisticsListSuccess = (ResultList) => {
  return {
    type: GET_STATISTICS_SUCCESS,
    payload: ResultList,
  };
};

export const getStatisticsListFail = (error) => {
  return {
    type: GET_STATISTICS_FAIL,
    payload: error,
  };
};

export const postValues = (result, id) => {
  return {
    type: POST_SERELOGY_VALUES,
    payload: { result, id },
  };
};

export const postValuesSuccess = (result) => ({
  type: POST_SERELOGY_VALUES_SUCCESS,
  payload: result,
});

export const postValuesFail = (error) => ({
  type: POST_SERELOGY_VALUES_FAIL,
  payload: error,
});

export const getResultValues = (id, round_id) => {
  // console.log("Fetching result values for ID:", id, "and round_id:", round_id);
  return {
    type: GET_SERELOGY_VALUES,
    payload: { id, round_id },
  };
};

export const getResultValuesSuccess = (ResultList) => {
  return {
    type: GET_SERELOGY_VALUES_SUCCESS,
    payload: ResultList,
  };
};

export const getResultValuesFail = (error) => {
  return {
    type: GET_SERELOGY_VALUES_FAIL,
    payload: error,
  };
};

export const getAnalyteResultParticipant = (schemeId, roundId, analyteId) => ({
  type: "GET_ANALYTE_RESULT_PARTICIPANT",   // saga will watch this
  payload: { schemeId, roundId, analyteId },
});
// Action on successful fetch
export function getAnalyteResultParticipantSuccess(
  getAnalyteResultParticipant
) {
  console.log(
    "GET_ANALYTE_RESULT_PARTICIPANT_SUCCESS:",
    getAnalyteResultParticipant
  );
  return {
    type: GET_ANALYTE_RESULT_PARTICIPANT_SUCCESS,
    payload: getAnalyteResultParticipant,
  };
}


// Action on failure
export function getAnalyteResultParticipantFail(error) {
  console.error("GET_ANALYTE_RESULT_PARTICIPANT_FAIL:", error);
  return {
    type: GET_ANALYTE_RESULT_PARTICIPANT_FAIL,
    payload: error,
  };
}

export const getmicroresultdata = (payload) => ({
  type: GET_MICRO_RESULT_DATA,
  payload,
});

export const getmicroresultdataSuccess = (data) => ({
  type: GET_MICRO_RESULT_DATA_SUCCESS,
  payload: data,
});

export const getmicroresultdataFail = (error) => ({
  type: GET_MICRO_RESULT_DATA_FAIL,
  payload: error,
});

export const postMicroResult = (result, id) => {
  console.log("🚀 Dispatching POST_RESULT Action:");
  console.log("📌 Result Data:", result);
  console.log("📌 User ID:", id);

  return {
    type: POST_MICRO_RESULT,
    payload: { result, id },
  };
};

export const postMicroResultSuccess = (result) => {
  console.log("✅ POST_RESULT_SUCCESS Action Dispatched:");
  console.log("📌 Response Data:", result);

  return {
    type: POST_MICRO_RESULT_SUCCESS,
    payload: result,
  };
};

export const postMicroResultFail = (error) => {
  console.error("❌ POST_RESULT_FAIL Action Dispatched:");
  console.error("📌 Error:", error);

  return {
    type: POST_MICRO_RESULT_FAIL,
    payload: error,
  };
};

export const postMicroValue = (payload) => {
  console.log("🚀 Dispatching POST_MICRO_VALUE Action:");
  console.log("📌 Payload Data:", payload);

  return {
    type: POST_MICRO_VALUE,
    payload, // send directly
  };
};

export const postMicroValueSuccess = (value) => {
  return {
    type: POST_MICRO_VALUE_SUCCESS,
    payload: value, // no wrapping
  };
};

export const postMicroValueFail = (error) => {
  return {
    type: POST_MICRO_VALUE_FAIL,
    payload: error,
  };
};
export const getMicroStatisticsList = (id) => ({
  type: GET_MICRO_STATISTICS, // 👈 saga listens for this
  payload: id,
});

// success/fail (unchanged)
export const getMicroStatisticsListSuccess = (data) => ({
  type: GET_MICRO_STATISTICS_SUCCESS,
  payload: data, // 👈 full API JSON
});

export const getMicroStatisticsListFail = (error) => ({
  type: GET_MICRO_STATISTICS_FAIL,
  payload: error,
});
export const getMicroValueList = (id) => ({
  type: GET_MICRO_VALUE_LIST,
  payload: id,
});

export const getMicroValueListSuccess = (data) => {
  return {
    type: GET_MICRO_VALUE_LIST_SUCCESS,
    payload: data,
  };
};
export const getMicroValueListFail = (error) => ({
  type: GET_MICRO_VALUE_LIST_FAIL,
  payload: error,
});

export const getAnalytesData = (id, page, limit, filters = {}) => {
  console.log("📢 Dispatching getAnalytesData with:", {
    id,
    page,
    limit,
    filters,
  });

  return {
    type: GET_ANALYTE_DATA,
    payload: { id, page, limit, filters },
  };
};

export const getAnalytesDataSuccess = (AnalyteData) => {
  return {
    type: GET_ANALYTE_DATA_SUCCESS,
    payload: AnalyteData,
  };
};

export const getAnalytesDataFail = (error) => {
  return {
    type: GET_ANALYTE_DATA_FAIL,
    payload: error,
  };
};

export const getResultAnalyteData = (id, page, limit, filters = {}) => {
  console.log("📢 Dispatching getResultAnalyteData with:", {
    id,
    page,
    limit,
    filters,
  });

  return {
    type: GET_RESULT_ANALYTE_DATA,
    payload: { id, page, limit, filters },
  };
};

export const getResultAnalyteDataSuccess = (ResultAnalyteData) => {
  return {
    type: GET_RESULT_ANALYTE_DATA_SUCCESS,
    payload: ResultAnalyteData,
  };
};

export const getResultAnalyteDataFail = (error) => {
  return {
    type: GET_RESULT_ANALYTE_DATA_FAIL,
    payload: error,
  };
};

export const updateMicroResult = (result, id) => {
  return {
    type: UPDATE_MICRO_RESULT,
    payload: { result, id },
  };
};

export const updateMicroResultSuccess = (result) => {
  return {
    type: UPDATE_MICRO_RESULT_SUCCESS,
    payload: result,
  };
};

export const updateMicroResultFail = (error) => {
  return {
    type: UPDATE_MICRO_RESULT_FAIL,
    payload: error,
  };
};

export const getQualitativeAssign = (params) => {
  return {
    type: GET_QUALITATIVE_ASSIGN,
    payload: params,
  };
};

export const getQualitativeAssignSuccess = (data) => {
  return {
    type: GET_QUALITATIVE_ASSIGN_SUCCESS,
    payload: data,
  };
};

export const getQualitativeAssignFail = (error) => {
  return {
    type: GET_QUALITATIVE_ASSIGN_FAIL,
    payload: error,
  };
};

export const saveStatisticsStatus = (payload) => ({
  type: SAVE_STATISTICS_STATUS_REQUEST,
  payload,
});

export const saveStatisticsStatusSuccess = (data) => ({
  type: SAVE_STATISTICS_STATUS_SUCCESS,
  payload: data,
});

export const saveStatisticsStatusFailure = (error) => ({
  type: SAVE_STATISTICS_STATUS_FAILURE,
  payload: error,
});
